import React, { useState } from "react";
import PaymentMethod from "./PaymentMethod";
import TotalSummary from "./TotalSummary";
import { DeliveryInfo } from "./DeliveryAddress";

interface PayMethodProps {
  onPaymentMethodChange: (method: string) => void;
  productId: string;
  deliveryInfo: DeliveryInfo;
}

const PayMethod: React.FC<PayMethodProps> = ({ onPaymentMethodChange, productId, deliveryInfo }) => {
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState<
    string | null
  >(null);

  const handlePaymentMethodChange = (method: string | null) => {
    setSelectedPaymentMethod(method);
    if (method) {
      onPaymentMethodChange(method);
    }
  };

  return (
    <>
      <PaymentMethod setSelectedPaymentMethod={handlePaymentMethodChange} productId={productId} />
      <TotalSummary
        selectedPaymentMethod={selectedPaymentMethod || "결제수단을 선택하세요"}
        deliveryInfo={deliveryInfo}
      />
    </>
  );
};

export default PayMethod;
